import { ToneDto } from '../tonedto';

export interface BannerSearchDto
{
    getSearchKey() : string;
    getLanguage(): string;
    getType(): string;
    getPageNumber(): number;
    getPagePerCount(): number;

    getListOfTones(): ToneDto[];
}

export class BannerSearchDtoImpl implements BannerSearchDto
{
    private searchKey: string;
    private language: string;
    private type: string;
    private pageNumber: number;
    private pagePerCount: number;
    private toneList: ToneDto[];

    getListOfTones(): ToneDto[] 
    {
        return this.toneList;
    }

    setListOfTones(toneList: ToneDto[])
    {
        this.toneList = toneList;
    }

    getSearchKey(): string
    {
        return this.searchKey;
    }
    setSearchKey(searchKey: string)
    {
        this.searchKey = searchKey;
    }

    setLanguage(language: string)
    {
        this.language = language;
    }
    getLanguage(): string 
    {
        return this.language;
    }

    setType(type: string)
    {
        this.type = type;
    }
    getType(): string 
    {
        return this.type;
    }  
    
    setPageNumber(pageNumber: number)
    {
        this.pageNumber = pageNumber;
    }
    getPageNumber(): number 
    {
        return this.pageNumber;
    }

    setPagePerCount(pagePerCount: number)
    {
        this.pagePerCount = pagePerCount;
    }
    getPagePerCount(): number 
    {
        return this.pagePerCount;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/bannersearch/bannersearchdto.ts